import { render, staticRenderFns } from "./InventorySheet.vue?vue&type=template&id=640d8187&scoped=true"
import script from "./InventorySheet.vue?vue&type=script&lang=js"
export * from "./InventorySheet.vue?vue&type=script&lang=js"
import style0 from "./InventorySheet.vue?vue&type=style&index=0&id=640d8187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d8187",
  null
  
)

export default component.exports